function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import styled from 'styled-components';
import { flexbox, layout, space } from 'styled-system';
import React from 'react';
import { createBreakpointMap } from '../helpers/styled-helpers';
import { rowStyles } from './style';
var StyledRowWithFlexboxAndSpaceProps = /*#__PURE__*/styled.div.withConfig({
  displayName: "row__StyledRowWithFlexboxAndSpaceProps",
  componentId: "ufsqtx-0"
})(["", ";", ";", ";", ";"], rowStyles, flexbox, layout, space);

var Row = props => {
  var reverseMap;
  var startMap;
  var centerMap;
  var endMap;
  var topMap;
  var middleMap;
  var bottomMap;
  var aroundMap;
  var betweenMap;

  var {
    reverse,
    start,
    center,
    end,
    top,
    middle,
    bottom,
    around,
    between
  } = props,
      styledSystemProps = _objectWithoutProperties(props, ["reverse", "start", "center", "end", "top", "middle", "bottom", "around", "between"]);

  if (reverse) {
    reverseMap = createBreakpointMap(reverse);
  }

  if (start) {
    startMap = createBreakpointMap(start);
  }

  if (center) {
    centerMap = createBreakpointMap(center);
  }

  if (end) {
    endMap = createBreakpointMap(end);
  }

  if (top) {
    topMap = createBreakpointMap(top);
  }

  if (middle) {
    middleMap = createBreakpointMap(middle);
  }

  if (bottom) {
    bottomMap = createBreakpointMap(bottom);
  }

  if (around) {
    aroundMap = createBreakpointMap(around);
  }

  if (between) {
    betweenMap = createBreakpointMap(between);
  }

  return /*#__PURE__*/React.createElement(StyledRowWithFlexboxAndSpaceProps, _extends({
    reverseMap: reverseMap,
    startMap: startMap,
    centerMap: centerMap,
    endMap: endMap,
    topMap: topMap,
    middleMap: middleMap,
    bottomMap: bottomMap,
    aroundMap: aroundMap,
    betweenMap: betweenMap
  }, styledSystemProps), props.children);
};

export default Row;